export interface OrderableFile {
    weight: number
    file_id: number | string
}

/**
 * Files that were just added client side have a temporary string id, so they sort
 * as the newest ones until the backend hands out a real file_id.
 */
const getOrderKey = (file: OrderableFile) =>
    typeof file.file_id === 'number' ? file.file_id : Number.MAX_SAFE_INTEGER

/**
 * The single ordering rule for provider files, mirroring FilesTable::ORDER on the
 * backend: explicit weight first, newest upload first for files that share a weight.
 * Most files never get an explicit weight, so without the file_id tie-break the order
 * differs between the pro dashboard and the public profile.
 */
export const compareFileOrder = (fileA: OrderableFile, fileB: OrderableFile) =>
    fileB.weight - fileA.weight || getOrderKey(fileB) - getOrderKey(fileA)
